import { type INotification, useMagicBellEvent } from '@magicbell/react-headless';

import { Icon } from '@gitbook/spine-icons';
import { toast } from '@gitbook/spine-react';

import { NotificationFormattedTitle } from './NotificationFormattedTitle';

/**
 * Hook to show new notifications to the user in a toast.
 */
export function useNotificationToasts() {
    useMagicBellEvent('notifications.new', (notification: INotification) => {
        toast('Notification', {
            icon: Icon.Bell,
            description: <NotificationFormattedTitle notification={notification} />,
        });
    });
}
